import React from "react";
import "./style.scss";
import { Collapse } from "antd";
import { MdKeyboardArrowUp, MdKeyboardArrowDown } from "react-icons/md";

const Index = () => {
  const items = [
    {
      key: "1",
      label: "What services do you provide?",
      children: (
        <p>
          We're like the local footy team of the digital world – a one-stop shop
          for all your online needs with top website developers. Need a snazzy
          logo to kick things off? We've got your back. After a full-blown
          website or a whiz-bang full stack application? No worries, we've got
          the skills to bring your ideas to life. Plus, we’ve got our own
          servers right here in London, so we can host your website on secure,
          local servers. It's all about giving you peace of mind and top-notch
          service, so you can get on with running your business.
        </p>
      ),
    },
    {
      key: "2",
      label: "What is a website platform?",
      children: (
        <div>
          <p>
            A website platform is a base framework or environment where your
            website is built and managed. Each platform has its own features and
            is suited for different needs. Here's a brief overview of various
            platforms:
          </p>
          <h2>WordPress Template</h2>
          <p>
            Utilizes pre-designed templates for quick and easy website setup,
            ideal for blogs and small business sites.
          </p>
          <h2>Custom WordPress</h2>
          <p>
            Offers a personalized touch to WordPress sites with custom themes
            and plugins for unique design and functionality.
          </p>
          <h2>Shopify</h2>
          <p>
            An e-commerce platform with built-in tools, perfect for creating
            online stores with minimal technical know-how.
          </p>
          <h2>Custom PHP</h2>
          <p>
            A general-purpose scripting language that can create bespoke and
            highly customizable websites from scratch.
          </p>
          <h2>Laravel</h2>
          <p>
            {" "}
            A PHP framework for web artisans, focusing on elegant coding and
            simplicity, with tools for robust application building. P.S. Our
            Laravel website development services are quite top-notch!
          </p>
          <h2>Node.js</h2>
          <p>
            {" "}
            A JavaScript runtime built on Chrome's V8 engine, enabling
            server-side scripting and creating dynamic page content before the
            page is sent to the user's web browser.
          </p>
          <h2>Three.js</h2>
          <p>
            {" "}
            A JavaScript library that creates and displays animated 3D computer
            graphics in a web browser, often used for games or interactive
            models.
          </p>
          <h2>Angular</h2>
          <p>
            {" "}
            A TypeScript-based open-source web application framework led by the
            Angular Team at Google and by a community of individuals and
            corporations to address challenges in developing single-page
            applications.
          </p>
          <h2>.NET</h2>
          <p>
            {" "}
            A free, cross-platform, open-source developer platform for building
            many different types of applications. With .NET, you can use
            multiple languages, editors, and libraries to build for web, mobile,
            desktop, games, and IoT.
          </p>
          <h2>React</h2>
          <p>
            {" "}
            A JavaScript library for building user interfaces, particularly
            single-page applications where you need a fast, interactive user
            experience. P.S. Our team is quite exceptional at React web design!
          </p>
          <h2>Python</h2>
          <p>
            {" "}
            A high-level, general-purpose programming language known for its
            readability and versatility. Used for web development, automation,
            data analysis, and more. P.S. We excel at Python web app
            development!
          </p>{" "}
        </div>
      ),
    },
    {
      key: "3",
      label: "Do I have ownership rights after developing the website?",
      children: (
        <div>
          <p>
            Yes, after your website is developed, you will have full 100%
            ownership rights. This means that you are the absolute owner of the
            website, just like buying a piece of property.
          </p>
          <p>
            For example, if we develop an e-commerce website for your business,
            you're like the landowner and the store owner. You have the freedom
            to decide how it looks, what products to sell, and how to manage it.
            You're not just renting space from us; you're hiring us to build
            your own digital 'property' that you will own completely. Whether
            it's the content, the design, or the code - it all belongs to you
            with our business website development solutions.
          </p>{" "}
        </div>
      ),
    },
    {
      key: "4",
      label: "What is a CMS?",
      children: (
        <div>
          <p>
            CMS, or Content Management System, is like a big digital filing
            cabinet for your website. It's a piece of software that lets you
            add, change, or delete the stuff on your website – like words,
            pictures, and videos – without having to be a computer whiz. You can
            think of it like using a program such as Microsoft Word to create a
            document; a CMS lets you put together and edit your website easily.
          </p>
          <p>
            It's a handy tool for anyone who wants to keep their website fresh
            and up-to-date, whether it’s adding a new blog post, changing the
            price on your product page, or just fixing a typo. Popular CMS
            options include WordPress, Joomla, and Drupal.
          </p>
          <p>
            They're chosen by many Aussies because they don't involve
            complicated code – it’s all about making changes as simple as
            sending an email or writing a Word doc. Hence, our team goes the
            extra mile in providing the best Custom CMS development solutions
            for your website!
          </p>{" "}
        </div>
      ),
    },
    {
      key: "5",
      label: "How do I manage my website after development?",
      children: (
        <div>
          <p>
            Once your website's all built and ready to go, managing it is a fair
            dinkum breeze. We'll sort you out with a video demonstration that
            walks you through how to update your content – like the words,
            photos, and videos – whenever you need to. It's as easy as pie and
            you won't need any techy know-how to do the basic stuff.
          </p>
          <p>
            But here's the deal, if you're wanting to change the look of the
            site – that's the design and layout, which we call the 'UI' or User
            Interface – you might need to call up a developer like us. That's
            because tweaking the UI is a bit more complex, and we want to make
            sure it’s done right so your site stays looking ace. Don't worry,
            our team is well equipped in the department of website design help!
          </p>{" "}
        </div>
      ),
    },
    {
      key: "6",
      label: "What is mobile responsive?",
      children: (
        <div>
          <p>
            Mobile responsive means your web and app design will look good and
            work well no matter what kind of gadget someone's viewing it on –
            whether that's a computer, a mobile phone, or a tablet. It's like
            when you put on a good pair of stretchy jeans; they fit you just
            right, whether you're standing up, sitting down, or running for the
            tram.
          </p>
          <p>
            So why's that important? Well, imagine you've got a bloke in London
            trying to buy footy boots from your online store, but he's on his
            mobile and the site's all over the shop – the pictures are too big,
            the text’s too small, and he can't find the 'buy' button. Chances
            are he'll give up and go elsewhere. You don’t want that.
          </p>
          <p>
            Having a mobile responsive site means no matter where your customers
            are or what device they're using, they can easily find what they
            need, have a squiz, and make a purchase without a hitch. It keeps
            them happy, which is good news for your business.
          </p>{" "}
        </div>
      ),
    },
  ];
  return (
    <div className="faq__main container">
      <h2 className="faq__heading">FAQs</h2>
      <Collapse
        expandIcon={({ isActive }) => (
          <button className="collapse__btn">
            {isActive ? (
              <MdKeyboardArrowUp color="rgb(201, 49, 114)" size={25} />
            ) : (
              <MdKeyboardArrowDown color="#fff" size={25} />
            )}
          </button>
        )}
        expandIconPosition="end"
        className="accordian__custom"
        accordion
        items={items}
      />
      ;
    </div>
  );
};

export default Index;
